var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "facebook-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(10.000000, 10.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7102774,69.5205479 C67.8143247,69.5205479 69.5205479,67.8143379 69.5205479,65.7097711 L69.5205479,4.28996097 C69.5205479,2.18512629 67.8145926,0.479452055 65.7102774,0.479452055 L4.28999054,0.479452055 C2.18513952,0.479452055 0.479452055,2.18512629 0.479452055,4.28996097 L0.479452055,65.7097711 C0.479452055,67.81407 2.18487163,69.5205479 4.28999054,69.5205479 L65.7102774,69.5205479 Z",
    id: "Blue_1_",
    fill: "#3C5A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1227876,67.6027397 L50.1227876,40.9211797 L59.1695789,40.9211797 L60.5242075,30.5229024 L50.1227876,30.5229024 L50.1227876,23.8842593 C50.1227876,20.873718 50.96727,18.8221335 55.3282236,18.8221335 L60.890411,18.8197274 L60.890411,9.51942473 C59.9284518,9.3927045 56.6266795,9.10958904 52.7853242,9.10958904 C44.765847,9.10958904 39.275496,13.9554349 39.275496,22.8544569 L39.275496,30.5229024 L30.2054795,30.5229024 L30.2054795,40.9211797 L39.275496,40.9211797 L39.275496,67.6027397 L50.1227876,67.6027397 Z",
    id: "f",
    fill: "#FFFFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.83985f511b923ecba24e3843d8d46791.svg";
export { ForwardRef as ReactComponent };